import { Component, OnInit, ViewChild } from '@angular/core';
import { AdmService } from 'src/app/service/adm.service';
import { Globals } from 'src/app/globals';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { CandPreviewService } from 'src/app/service/cand-preview.service';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-cand-preview',
  templateUrl: './cand-preview.component.html',
  styleUrls: ['./cand-preview.component.scss']
})
export class CandPreviewComponent implements OnInit {
  showLoader = false;
  // showAcceptModal = false;
  // showRejectModal = false;
  appStatues: any;
  candData: any;
  candId: any;
  candStatusNotAllowLimit = 27;
  updating = false;
  candFlag = false;
  pendingEvalStatus = 27;
  rejectStatus = 70;
  pendingCandStatus = 25;
  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth() + 1;
  day = this.now.getDate();
  minDate = (this.year) + "-" + ("0" + this.month).slice(-2) + "-" + ("0" + this.day).slice(-2);

  @ViewChild('closeVerifyAlert') private closeVerifyAlert: any;

  applicationVerifyPopUp = new FormGroup({
    interViewDate: new FormControl('', [
      Validators.required,
    ]),
    patchNumber: new FormControl('', [
      Validators.required,
    ]),
    interViewTime: new FormControl('', [
      Validators.required,
    ]),
  });
  constructor(public globals: Globals, private admService: AdmService, private toastrService: ToastrService, public translate: TranslateService, private activatedRoute: ActivatedRoute, private router: Router, private candPreviewService: CandPreviewService, private location: Location) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.candId = params['candId'] || "";

        if (this.candId != "") {
          console.log("candId : " + this.candId)
          this.showLoader = true;
          // this.getAllAPIs();
          // this.getAppStatuses();
          this.getCandById(this.candId);
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          // this.router.navigate(['/admission/candidate-inquiry']);
          this.location.back();
        }
      });
    console.log("this.globals.candidateId : " + this.globals.candidateId);
    if (typeof this.globals.candidateId != undefined && this.globals.candidateId != null && this.globals.candidateId != 0) {
      console.log("true");
      this.candFlag = false;
    } else {
      console.log("false");
      this.candFlag = true;
    }
  }

  activateNumber(tabIndex: number) {
    console.log(tabIndex);
  }

  // getAllAPIs() {
  //   this.candPreviewService.getPreviewCandData(120).subscribe(
  //     data => {
  //       console.log(data);
  //     },
  //     error => {
  //       this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //       this.router.navigate(['/admission/candidate-inquiry']);
  //     }
  //   );
  // }

  getCandById(candId: number) {
    this.admService.getCandidateById(candId).subscribe(
      data => {
        // console.log(data);
        this.candData = data;
        this.candData.profileImagePath = "";
        this.candData.bachlorCertFilenamePath = "";
        this.candData.bachlorCardFilenamePath = "";

        this.candData.appStatusNameAr = "";
        this.candData.appStatusNameEn = "";
        this.candData.maritalStatusNameAr = "";
        this.candData.maritalStatusNameEn = "";
        this.candData.militaryStatusNameAr = "";
        this.candData.militaryStatusNameEn = "";
        this.candData.liveWithNameAr = "";
        this.candData.liveWithNameEn = "";
        this.candData.countryNameAr = "";
        this.candData.countryNameEn = "";
        this.candData.regionNameAr = "";
        this.candData.regionNameEn = "";
        this.candData.provinceNameAr = "";
        this.candData.provinceNameEn = "";
        this.candData.cityNameAr = "";
        this.candData.cityNameEn = "";
        this.candData.profileImagePath = `${environment.API_URL_UTIL}/api/downloadFile/${this.candData.photoFilename}`;
        this.candData.bachlorCertFilenamePath = `${environment.API_URL_UTIL}/api/downloadFile/${this.candData.bachlorCertFilename}`;
        this.candData.bachlorCardFilenamePath = `${environment.API_URL_UTIL}/api/downloadFile/${this.candData.bachlorCardFilename}`;
        this.candData.nIdFilenamePath = `${environment.API_URL_UTIL}/api/downloadFile/${this.candData.nidFilename}`;

        if (data.appstatusid >= this.pendingCandStatus) {
          this.getLookupData();
        } else {
          this.candData.appStatusNameAr = "طلب جديد";
          this.candData.appStatusNameEn = "NEW";
          this.showLoader = false;
        }
        // let CandDataArray = [data];
        // let candMappedData = CandDataArray.map((cand: any) => {
        //   let statusId = cand.appstatusid;
        //   cand.appStatusNameAr = "";
        //   cand.appStatusNameEn = "";
        //   cand.profileImagePath = "";
        //   cand.bachlorCertFilenamePath = "";
        //   cand.bachlorCardFilenamePath = "";
        //   if (typeof statusId != 'undefined' && statusId > 0) {
        //     let getAppStatus = this.appStatues.filter((i: any) => i.id == statusId)[0];
        //     if (typeof getAppStatus != 'undefined') {
        //       cand.appStatusNameAr = getAppStatus.appStatusNameAr;
        //       cand.appStatusNameEn = getAppStatus.appStatusNameEn;
        //     }
        //     cand.profileImagePath = `${environment.API_URL_UTIL}/api/downloadFile/${cand.photoFilename}`;
        //     cand.bachlorCertFilenamePath = `${environment.API_URL_UTIL}/api/downloadFile/${cand.bachlorCertFilename}`;
        //     cand.bachlorCardFilenamePath = `${environment.API_URL_UTIL}/api/downloadFile/${cand.bachlorCardFilename}`;
        //     console.log(cand.bachlorCertFilenamePath);
        //     // photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;
        //   }
        //   return cand;
        // });
        // this.candData = candMappedData[0];
        // this.showLoader = false;
        // console.log(data.nidNo);
        // nidNo
        // emailAddress1
        // bachlorCertFilename
        // bachlorCardFilename
        // candCode: new FormControl(''),

        // natId: new FormControl(''),
        // userEmail: new FormControl(''),
        // bachelorCert: new FormControl(''),
        // bachelorCard: new FormControl(''),
        // this.basicData.controls.candCode.setValue(data.candCode);
        // this.basicData.controls.natId.setValue(data.nidNo);
        // this.basicData.controls.userEmail.setValue(data.emailAddress1);
        // this.basicData.controls.bachelorCert.setValue(data.bachlorCertFilename);
        // this.basicData.controls.bachelorCard.setValue(data.bachlorCardFilename);
      },
      error => {
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        this.showLoader = false;
        // this.router.navigate(['/admission/candidate-inquiry']);
        this.location.back();
      }
    );
  }

  // getAppStatuses() {
  //   this.showLoader = true;
  //   this.admService.getAppStatuses().subscribe(
  //     data => {
  //       this.appStatues = data;
  //       this.getCandById(this.candId);
  //       // this.getCandById(120);
  //     },
  //     error => {
  //       this.toastrService.error(this.translate.instant("CAN_NOT_GET_APP_STATUSES"));
  //       this.showLoader = false;
  //       this.router.navigate(['/admission/candidate-inquiry']);
  //     })
  // }

  getLookupData() {
    this.showLoader = true;
    // getPreviewCandData(appStatusId: number,maritalId: number, militaryStatusId: number,liveWithId: number, countryId: number, regionId: number, provinceId: number, cityId: number) {
    let appStatusId = this.candData.appstatusid;
    let maritalId = this.candData.maritalStatusid;
    let militaryStatusId = this.candData.milStatusid;
    let liveWithId = this.candData.livewithid;
    let countryId = this.candData.addressCountryid;
    let regionId = this.candData.addressRegionid;
    let provinceId = this.candData.addressProvinceid;
    let cityId = this.candData.addressCityid;

    this.candPreviewService.getPreviewCandData(appStatusId, maritalId, militaryStatusId, liveWithId, countryId, regionId, provinceId, cityId).subscribe(
      data => {
        // console.log("look data");
        // console.log(data);
        let CandDataArray = [this.candData];
        let candMappedData = CandDataArray.map((cand: any) => {
          // let statusId = cand.appstatusid;

          // cand.profileImagePath = "";
          // cand.bachlorCertFilenamePath = "";
          // cand.bachlorCardFilenamePath = "";

          // cand.appStatusNameAr = "";
          // cand.appStatusNameEn = "";
          let candAppStatusObj: any = data[0];
          cand.appStatusNameAr = candAppStatusObj.appStatusNameAr;
          cand.appStatusNameEn = candAppStatusObj.appStatusNameEn;

          // cand.maritalStatusNameAr = "";
          // cand.maritalStatusNameEn = "";
          let maritalStatusObj: any = data[1];
          cand.maritalStatusNameAr = maritalStatusObj.maritalStatusNameAr;
          cand.maritalStatusNameEn = maritalStatusObj.maritalStatusNameEn;

          // cand.militaryStatusNameAr = "";
          // cand.militaryStatusNameEn = "";
          let militaryStatusObj: any = data[2];
          cand.militaryStatusNameAr = militaryStatusObj.milStatusNameAr;
          cand.militaryStatusNameEn = militaryStatusObj.milStatusNameEn;

          // cand.liveWithNameAr = "";
          // cand.liveWithNameEn = "";
          let liveWithObj: any = data[3];
          cand.liveWithNameAr = liveWithObj.livewithNameAr;
          cand.liveWithNameEn = liveWithObj.livewithNameEn;

          // cand.countryNameAr = "";
          // cand.countryNameEn = "";
          let countryObj: any = data[4];
          cand.countryNameAr = countryObj.countryNameAr;
          cand.countryNameEn = countryObj.countryNameEn;

          // cand.regionNameAr = "";
          // cand.regionNameEn = "";
          let regionObj: any = data[5];
          cand.regionNameAr = regionObj.regionNameAr;
          cand.regionNameEn = regionObj.regionNameEn;

          // cand.provinceNameAr = "";
          // cand.provinceNameEn = "";
          let provinceObj: any = data[6];
          cand.provinceNameAr = provinceObj.provinceNameAr;
          cand.provinceNameEn = provinceObj.provinceNameEn;

          // cand.cityNameAr = "";
          // cand.cityNameEn = "";
          let cityObj: any = data[7];
          cand.cityNameAr = cityObj.cityNameAr;
          cand.cityNameEn = cityObj.cityNameEn;

          // if (typeof statusId != 'undefined' && statusId > 0) {
          // let getAppStatus = this.appStatues.filter((i: any) => i.id == statusId)[0];
          // if (typeof getAppStatus != 'undefined') {
          //   cand.appStatusNameAr = getAppStatus.appStatusNameAr;
          //   cand.appStatusNameEn = getAppStatus.appStatusNameEn;
          // }
          // cand.profileImagePath = `${environment.API_URL_UTIL}/api/downloadFile/${cand.photoFilename}`;
          // cand.bachlorCertFilenamePath = `${environment.API_URL_UTIL}/api/downloadFile/${cand.bachlorCertFilename}`;
          // cand.bachlorCardFilenamePath = `${environment.API_URL_UTIL}/api/downloadFile/${cand.bachlorCardFilename}`;
          // console.log(cand.bachlorCertFilenamePath);
          // photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;
          // }
          return cand;
        });
        this.candData = candMappedData[0];
        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
        // this.router.navigate(['/admission/candidate-inquiry']);
        this.location.back();
      })
  }

  changeCandStatus(candStatus: number) {
    this.updating = true;
    // this.showAcceptModal = true;
    // this.showRejectModal = true;
    this.admService.updateStatusEnglishTest(this.candId, candStatus)
      .subscribe(
        data => {
          this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
          // this.router.navigate(['/admission/candidate-inquiry']);
          this.location.back();
          // window.location.reload();
        },
        error => {
          this.updating = false
          this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
        },
        () => this.updating = false
      );
  }

  changeCandStatusToVerify(candStatus: number) {
    if (this.applicationVerifyPopUp.valid) {

      // this.showAcceptModal = true;
      // this.showRejectModal = true;
      let patchNumber = this.applicationVerifyPopUp.controls.patchNumber.value;
      let interViewDate = this.applicationVerifyPopUp.controls.interViewDate.value + " " + this.applicationVerifyPopUp.controls.interViewTime.value + ":00";
      let username = this.globals.currentUserInfo.username;
      let intrViewDateObj = new Date(interViewDate);
      let currentDate = new Date();
      // console.log("patchNumber");
      // console.log(interViewDate);
      this.closeVerifyAlert.nativeElement.click();
      this.updating = true;
      // (id: number, username: string, appstatusid: number, verifiedBy: string, verificationDate: any, invitationDate: any, invitationBatch: string, invitationBy: string) {
      this.admService.candVerify(this.candId, username, candStatus, username, currentDate, intrViewDateObj, patchNumber, username)
        .subscribe(
          data => {
            this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
            // this.router.navigate(['/admission/candidate-inquiry']);
            this.location.back();
            // window.location.reload();
          },
          error => {
            this.updating = false
            this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
          },
          () => this.updating = false
        );
      // this.admService.updateStatusEnglishTest(this.candId, candStatus)
      //   .subscribe(
      //     data => {
      //       this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
      //       // this.router.navigate(['/admission/candidate-inquiry']);
      //       this.location.back();
      //       // window.location.reload();
      //     },
      //     error => {
      //       this.updating = false
      //       this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
      //     },
      //     () => this.updating = false
      //   );
    } else {
      this.applicationVerifyPopUp.markAllAsTouched();
      this.applicationVerifyPopUp.markAsDirty();
    }
  }

  //update cand email popup 
  updateEmailPopUp = new FormGroup({  
    updatedEmail:new FormControl(null, {validators: [Validators.required, Validators.email]}),
  });

  updateCandEmail() {
    this.updating = true;
    if (this.updateEmailPopUp.valid) {
      let userName = this.globals.currentUserInfo.username;
      let updatedEmail = this.updateEmailPopUp.controls.updatedEmail.value;
      this.candPreviewService.updateCandEmail(this.globals.orgId, this.candId, updatedEmail, userName)
        .subscribe(
          data => {
            this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
            $('#close-UpdateEmailPopUp').click();
            // this.location.back();
            window.location.reload();
          },
          error => {
            this.updating = false
            console.log(error);
            this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
          },
          () => this.updating = false
        );
    } else
      this.toastrService.error(this.translate.instant('INVALID_EMAIL'));
  }

  // update cand NationalId PopUp 
  updateCandNationalIdPopUp = new FormGroup({  
    updatedNationalId:new FormControl(null, {validators: [Validators.required]}),
  });

  updateCandNationalId() {
    this.updating = true;
    if (this.updateCandNationalIdPopUp.valid) {
      let userName = this.globals.currentUserInfo.username;
      let updatedNationalId = this.updateCandNationalIdPopUp.controls.updatedNationalId.value;
      this.candPreviewService.updateCandNationalId(this.globals.orgId, this.candId, updatedNationalId, userName)
        .subscribe(
          data => {
            this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
            $('#close-UpdateNationalIdPopUp').click();
            // this.location.back();
            window.location.reload();
          },
          error => {
            this.updating = false
            console.log(error);
            this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
          },
          () => this.updating = false
        );
    } else
      this.toastrService.error(this.translate.instant('INVALID_NATIONAL_ID'));
  }

  onSendingVerficationMail() {
    this.updating = true;
      this.candPreviewService.sendingVerficationMail(this.candId)
        .subscribe(
          data => {
            this.toastrService.success(this.translate.instant("SEND_VERFICATION_MAIL_SENT"));
          },
          error => {
            this.updating = false
            console.log(error);
            this.toastrService.error(this.translate.instant('SEND_VERFICATION_MAIL_NOT_SENT'));
          },
          () => this.updating = false
        );
  }

   //archieving Cand popup 
   archievingCandPopUp = new FormGroup({  
    remarks:new FormControl(null, {validators: [Validators.required]}),
  });


  onCandArchieving() {
    this.updating = true;
    let username = this.globals.currentUserInfo.username;
    let remarks = this.archievingCandPopUp.controls.remarks.value;
      this.candPreviewService.onCandArchieving(this.globals.orgId,this.candId,username,remarks)
        .subscribe(
          data => {    
            this.toastrService.success(this.translate.instant("ARCHIEVING_SUCCESS"));
            $('#close-ArchievingCandPopUp').click();
            // window.location.reload();
          },
          error => {
            this.updating = false
            console.log(error);
            this.toastrService.error(this.translate.instant('ARCHIEVING_FAIL'));
          },
          () => this.updating = false
        );
  }
}
